import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Footer from "../layouts/Footer";
import biz from "../assets/img/Turbnew.jpg";
import MenuBar from "../layouts/MenuBar";
import Hero from "../layouts/Hero";
import { Link } from "react-router-dom";
import plans from "../data/plans";

const container = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.12, delayChildren: 0.1 },
  },
};

const card = {
  hidden: { opacity: 0, y: 32 },
  show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

function Pricing() {
  useEffect(() => {
    const timer = setTimeout(() => {
      document.getElementById("plans")?.scrollIntoView({ behavior: "smooth" });
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <MenuBar />

      <Hero
        title={
          <>
            Hybrid <span className="text-brand-teal">Internet</span> that
            never slows you down
          </>
        }
        description="We offer different UNLIMITED plans with no data cap, no usage threshold and no limited number of devices that can be connected. Select your preferred plan below."
        image={biz}
        imageAlt="Hybrid Internet"
        badges={[
          { position: "bottom", icon: "fa-bolt", text: "Up to 100Mbps hybrid speed" },
          {
            position: "top",
            icon: "fa-infinity",
            iconColor: "text-brand-green",
            text: "Unlimited Data",
          },
        ]}
        actions={[
          {
            label: "View Plans",
            href: "#plans",
            onClick: (e) => {
              e.preventDefault();
              document.getElementById("plans")?.scrollIntoView({ behavior: "smooth" });
            },
            icon: <i className="fa fa-arrow-down text-sm" />,
          },
          {
            label: "Talk to Sales",
            href: "http://wifi.com.ng/contact-us/",
            variant: "secondary",
          },
        ]}
      />

      <div className="relative overflow-hidden bg-white">

        <motion.div
          id="plans"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="flex flex-wrap justify-center items-stretch gap-10 mt-20 pb-16 px-5 scroll-mt-[112px] sm:scroll-mt-[128px] md:scroll-mt-[152px]"
        >
          {plans.map((item) => (
            <motion.div
              key={item.slug}
              variants={card}
              whileHover={{ y: -8, boxShadow: "0px 20px 30px 0px rgba(0,0,0,0.08)" }}
              style={{ borderTopColor: item.border }}
              className={`relative flex-none w-full max-w-[420px] flex flex-col text-left rounded-3xl border-t-4 bg-white shadow-[0px_10px_25px_0px_#00000008] p-10 transition-shadow ${
                item.featured ? "ring-2 ring-brand-teal md:scale-105" : ""
              }`}
            >
              {item.featured && (
                <motion.span
                  initial={{ opacity: 0, scale: 0.6 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ delay: 0.4, type: "spring", stiffness: 300 }}
                  className="absolute -top-3 right-6 rounded-full bg-brand-teal px-3 py-1 text-xs font-bold uppercase tracking-wide text-white shadow"
                >
                  Most Popular
                </motion.span>
              )}

              <h3 className="text-2xl font-bold text-brand-dark">{item.title}</h3>

              <p className="mt-3 flex items-baseline gap-1.5 text-4xl font-extrabold text-brand-dark">
                &#8358;{item.amount}
                <span className="text-base font-medium text-gray-500">/month</span>
              </p>

              <p className="mt-4 text-base leading-relaxed text-gray-600">
                {item.description}
              </p>

              <ul className="mt-6 mb-2 space-y-4 text-[15px] list-none">
                {[
                  "Plus ₦285,000 One Time Set Up Fee",
                  "Unlimited Data",
                  "P2P Dedicated Link",
                  "Stable Connection",
                  "Free WiFi Call Line",
                  item.speed,
                ].map((feature) => (
                  <li key={feature} className="flex items-start gap-2.5">
                    <i className="fa fa-check-square mt-1 text-brand-teal" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <motion.div whileHover={{ scale: 1.04 }} whileTap={{ scale: 0.97 }} className="mt-auto pt-6">
                <Link
                  className="flex items-center justify-center w-full h-14 rounded-xl bg-brand-teal text-white font-semibold text-base no-underline hover:bg-brand-teal-dark transition-colors"
                  to={{
                    pathname: "/signup",
                    state: {
                      plan: item.plan,
                      amount: item.price,
                      planName: item.slug,
                    },
                  }}
                >
                  Get Started
                </Link>
              </motion.div>
            </motion.div>
          ))}
        </motion.div>
      </div>

      <Footer />
    </>
  );
}

export default Pricing;